import { ClusterStatus } from "@/domain/cluster/constants"
import { useGetClusters } from "@/networking/api"
import { useMemo } from "react"

// Active BUs of the given sharing groups (BARNES SAS, BARNES Provence...)
export const useGetSharingGroupClusters = (typeCodes: string[]) => {
  const data = useGetClusters(
    {
      "type.code[]": typeCodes,
      "status.code": ClusterStatus.ACTIVE,
      itemsPerPage: 200,
      withMinProps: true,
    },
    { query: { enabled: typeCodes.length > 0 } }
  )

  const clusters = useMemo(() => {
    const clusters = typeCodes.length > 0 ? (data.data?.["hydra:member"] ?? []) : []
    const clusterIds = clusters.map(c => c.id)
    return { clusters, clusterIds }
  }, [data, typeCodes])

  return {
    ...data,
    ...clusters,
  }
}
